import { Action, createAction, props } from '@ngrx/store';
import { Session } from '@ory/client';
import { RuleDto } from '@careapp-group/ng-sdk-v2-new';

export const APPLICATION_AUTHORIZED = '[Application] Auth OK';
export const APPLICATION_READY = '[Application] Ready';
export const APPLICATION_SESSION_READY = '[Application] Session Ready';
export const APPLICATION_LOGIN_PROCESS_COMPLETE = '[Application] Login Complete';

/**
 * Initial required requests have all fired and the first screen can be shown
 */
export class ApplicationReady implements Action {
  readonly type = APPLICATION_READY;
  constructor() {}
}

/**
 * Initial required requests have all fired and the user is logged in
 */
export class ApplicationAuthorized implements Action {
  readonly type = APPLICATION_AUTHORIZED;
  constructor(public payload: any = {}) {}
}

export class ApplicationLoginComplete implements Action {
  readonly type = APPLICATION_LOGIN_PROCESS_COMPLETE;
  constructor(public payload: any = {}) {}
}

export const SessionReadyAction = createAction(
  APPLICATION_SESSION_READY,
  props<{ session: Session; userId: string }>()
);

export const RefreshAppStartup = createAction('[Application] Refresh app startup');

export const ResponseSuccessFetchAbility = createAction(
  '[Application][Success] fetch ability',
  props<{ ability: RuleDto[] }>()
);
